import { Form, Input, Select } from "antd";
import type { ResourceLinkInput } from "@/common/artemis-sdk/graphql";
import { LinkType } from "@/common/model";
import { Wizard } from "@/components/wizard";

const LINK_TYPE_OPTIONS: { value: LinkType; label: string }[] = [
	{ value: LinkType.GENERIC, label: "Generic" },
	{ value: LinkType.SOURCE_CODE, label: "Source Code" },
	{ value: LinkType.DOCUMENTATION, label: "Documentation" },
	{ value: LinkType.TOOL, label: "Tool" },
];

interface AddLinkModalProps {
	open: boolean;
	onClose: () => void;
	onAdd: (link: ResourceLinkInput) => void;
}

/** Drawer wizard for adding a new resource link to a project. */
export function AddLinkModal({ open, onClose, onAdd }: AddLinkModalProps) {
	const [form] = Form.useForm<ResourceLinkInput>();

	const handleComplete = () => {
		form.validateFields().then((values) => {
			onAdd(values);
			form.resetFields();
			onClose();
		});
	};

	const handleCancel = () => {
		form.resetFields();
		onClose();
	};

	return (
		<Wizard
			open={open}
			title="Add Link"
			completeLabel="Add"
			form={form}
			onComplete={handleComplete}
			onCancel={handleCancel}
			pages={[
				{
					id: "link",
					title: "Link",
					content: (
						<>
							<Form.Item
								name="url"
								label="URL"
								rules={[{ required: true, type: "url" }]}
							>
								<Input placeholder="https://..." />
							</Form.Item>
							<Form.Item name="name" label="Name">
								<Input placeholder="Link name" />
							</Form.Item>
							<Form.Item
								name="type"
								label="Type"
								initialValue={LinkType.GENERIC}
								rules={[{ required: true }]}
							>
								<Select options={LINK_TYPE_OPTIONS} />
							</Form.Item>
							<Form.Item name="description" label="Description">
								<Input.TextArea rows={2} placeholder="Optional description" />
							</Form.Item>
						</>
					),
				},
			]}
		/>
	);
}
